import { Text, TextProps, useTheme } from 'bold-ui'
import React from 'react'

export function LinhaTooltipGrafico(props: TextProps) {
  const theme = useTheme()
  return <Text component='p' style={{ color: theme.pallete.gray.c100 }} {...props} />
}
